import { useDispatch, useSelector } from "react-redux";

import {
    cancelAccountsExportThunk,
    confirmAccountsCrmPreviewExportThunk,
} from "../../store/effects";
import { selectAccountsExportPhase, selectAccountsIntegration } from "../../store/selectors";

import { AccountsExportPreviewModal } from "../AccountsExportPreviewModal/AccountsExportPreviewModal";
import { AccountsLoadingModal } from "../AccountsLoadingModal/AccountsLoadingModal";

const AccountsExportPreviewModalContainer = () => {
    const dispatch = useDispatch();

    const phase = useSelector(selectAccountsExportPhase);
    const integration = useSelector(selectAccountsIntegration);

    const isPreviewVisible = phase.type === "previewingAccounts";
    const isLoadingVisible = phase.type === "matchingAccounts" || phase.type === "exportingAccounts";

    const handleConfirmExport = () => {
        void dispatch(confirmAccountsCrmPreviewExportThunk());
    };

    const handleCancel = () => {
        dispatch(cancelAccountsExportThunk());
    };

    if (!integration) {
        return null;
    }

    return (
        <>
            <AccountsExportPreviewModal
                isOpen={isPreviewVisible}
                integrationName={integration}
                onExport={handleConfirmExport}
                onCancel={handleCancel}
            />
            <AccountsLoadingModal
                isOpen={isLoadingVisible}
                onClose={handleCancel}
            />
        </>
    );
};

export default AccountsExportPreviewModalContainer;
